import { periodicidade } from '@/locales/plan'
import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useNavigate, useOutletContext, useParams } from 'react-router-dom'
import { PlanoFixo, planos } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirPlano() {
    const navigate = useNavigate()
    const { planoId } = useParams()
    const handleBack = () => navigate('/administracao/planos-precos')

    const { data } = useOutletContext<{ data?: PlanoFixo[] }>()
    const plano = data?.find(item => item.id === Number(planoId))

    const { mutate, isLoading } = planos.mutations.useDelete({
        invalidateQuery: true,
    })

    function handleSubmit() {
        mutate(plano!.id, {
            onSuccess: () => {
                toast.success('Plano removido com sucesso!')
                handleBack()
            },
            onError: () => {
                toast.error('Erro ao remover plano')
            },
        })
    }

    if (!plano) return null

    return (
        <ConfirmarExclusao
            width="md"
            onClose={handleBack}
            loading={isLoading}
            onConfirm={handleSubmit}
            fecharAoConfirmar={false}
            title={
                <>
                    Você tem certeza que deseja excluir o plano{' '}
                    {plano.limiteFuncionarios} -{' '}
                    {periodicidade[plano.periodicity]}? Essa ação é
                    irreverssível!
                </>
            }
        />
    )
}
